/**
 * Breadcrumbs Enhancement
 * Usa el breadcrumb guardado en sessionStorage desde el header
 */

class BreadcrumbsEnhancer {
  constructor() {
    this.init();
  }

  init() {
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.enhanceBreadcrumbs());
    } else {
      setTimeout(() => this.enhanceBreadcrumbs(), 100);
    }
  }

  enhanceBreadcrumbs() {
    const breadcrumbsNav = document.querySelector('.breadcrumbs');
    if (!breadcrumbsNav) {
      return;
    }

    let savedBreadcrumb = null;
    
    try {
      const saved = sessionStorage.getItem('breadcrumb_navigation_path');
      if (saved) {
        savedBreadcrumb = JSON.parse(saved);
      }
    } catch (e) {
      return;
    }

    if (savedBreadcrumb && savedBreadcrumb.path && savedBreadcrumb.path.length > 0) {
      
      const breadcrumbsList = breadcrumbsNav.querySelector('.breadcrumbs__list');
      if (breadcrumbsList) {
        let productTitle = 'Product';
        let productUrl = window.location.pathname;
        const currentPath = window.location.pathname;
        
        if (currentPath.includes('/products/')) {
          const existingProductLink = breadcrumbsNav.querySelector('.breadcrumbs__link--current');
          if (existingProductLink) {
            productTitle = existingProductLink.textContent.trim();
            productUrl = existingProductLink.href || currentPath;
          } else {
            const pageTitle = document.querySelector('h1');
            if (pageTitle) {
              productTitle = pageTitle.textContent.trim();
            }
          }
        }
        
        const lastPathItem = savedBreadcrumb.path[savedBreadcrumb.path.length - 1];
        const isLastItemProduct = lastPathItem && 
          (lastPathItem.url === currentPath || 
           lastPathItem.url.includes('/products/') && currentPath.includes('/products/'));
        
        breadcrumbsList.innerHTML = '';
        
        const shopAllUrl = savedBreadcrumb.path[0]?.url || '/collections/all';
        const shopAllLi = document.createElement('li');
        shopAllLi.className = 'breadcrumbs__item';
        const shopAllAnchor = document.createElement('a');
        shopAllAnchor.href = shopAllUrl;
        shopAllAnchor.className = 'breadcrumbs__link';
        shopAllAnchor.textContent = 'Shop All';
        shopAllLi.appendChild(shopAllAnchor);
        breadcrumbsList.appendChild(shopAllLi);

        const pathToShow = savedBreadcrumb.path.length > 1 ? savedBreadcrumb.path.slice(1) : savedBreadcrumb.path;
        
        pathToShow.forEach((crumb) => {
          const li = document.createElement('li');
          li.className = 'breadcrumbs__item';
          
          const separator = document.createElement('span');
          separator.className = 'breadcrumbs__separator';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = '/';
          
          const link = document.createElement('a');
          link.href = crumb.url;
          
          const isCurrentProduct = isLastItemProduct && crumb === lastPathItem;
          link.className = isCurrentProduct ? 'breadcrumbs__link breadcrumbs__link--current' : 'breadcrumbs__link';
          link.textContent = crumb.title.toLowerCase().replace(/^\w/, c => c.toUpperCase());;
          
          if (isCurrentProduct) {
            link.setAttribute('aria-current', 'page');
          }
          
          li.appendChild(separator);
          li.appendChild(link);
          breadcrumbsList.appendChild(li);
        });

        if (currentPath.includes('/products/') && !isLastItemProduct) {
          const productLi = document.createElement('li');
          productLi.className = 'breadcrumbs__item';
          
          const productSeparator = document.createElement('span');
          productSeparator.className = 'breadcrumbs__separator';
          productSeparator.setAttribute('aria-hidden', 'true');
          productSeparator.textContent = '/';
          
          const productLink = document.createElement('a');
          productLink.href = productUrl;
          productLink.className = 'breadcrumbs__link breadcrumbs__link--current';
          productLink.setAttribute('aria-current', 'page');
          productLink.textContent = productTitle;
          
          productLi.appendChild(productSeparator);
          productLi.appendChild(productLink);
          breadcrumbsList.appendChild(productLi);
        }

        breadcrumbsNav.dataset.breadcrumbsSource = 'sessionStorage';
        return;
      }
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname.includes('/products/')) {
      new BreadcrumbsEnhancer();
    }
  });
} else {
  if (window.location.pathname.includes('/products/')) {
    new BreadcrumbsEnhancer();
  }
}

export default BreadcrumbsEnhancer;

